import {
    Button,
    SxProps,
    Typography,
    TypographyProps,
    TypographyPropsVariantOverrides,
} from "@mui/material";
import * as React from "react";
import {ComponentConfig} from "../../Config/ComponentConfig.js";
import {Colors} from "../../Constants/Colors.js";
import hexToRgba from "../../Helper/HexToRGBA";

interface PrimaryButtonProps {
    text: string;
    onTap: (event?: any) => void;
    variant?: "text" | "outlined" | "contained";
    backgroundColor?: string;
    borderColor?: string;
    textColor?: string;
    fullWidth?: boolean;
    sx?: SxProps;
    textStyle?: SxProps;
    textVariant?: TypographyPropsVariantOverrides | TypographyProps["variant"];
    textClassName?: string;
    disabled?: boolean;
    endIcon?: React.ReactNode;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
                                                         text,
                                                         onTap,
                                                         variant,
                                                         backgroundColor,
                                                         borderColor,
                                                         textColor,
                                                         fullWidth = true,
                                                         sx,
                                                         textStyle,
                                                         textVariant = "smallRegular",
                                                         textClassName = "small-regular",
                                                         disabled = false,
                                                         endIcon,
                                                     }) => {
    return (
        <Button
            variant={variant}
            onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onTap(event);
            }}
            fullWidth={fullWidth}
            disabled={disabled}
            endIcon={endIcon}
            sx={{
                padding: ComponentConfig.ButtonPadding,
                borderRadius: ComponentConfig.ButtonBorderRadius,
                textTransform: "none",
                borderColor: borderColor ?? Colors.greenBorderColor,
                backgroundColor:
                    backgroundColor ?? Colors.appointmentCardBgColorOpacity6,
                color: textColor ?? Colors.primaryTextColor,
                opacity: disabled ? 0.5 : 1,
                "&:hover": {
                    backgroundColor:
                        backgroundColor ?? hexToRgba(Colors.appointmentCardBgColor, 0.6),
                },
                ...sx,
            }}
        >
            <Typography
                variant={textVariant}
                className={textClassName}
                sx={{
                    ...textStyle,
                }}
            >
                {text}
            </Typography>
        </Button>
    );
};

export default PrimaryButton;
